<template>
  <!-- OpenPay -->
  <div id="openpay-method">
    <div v-show="is_openpay">
      <div class="py-2">
        <div class="form" id="op_processCard">
          <div class="row">
            <div class="col-6">
              <p class="mb-1 mb-sm-2 text-left">Tarjetas de Crédito</p>
              <div class="row mb-4">
                <div class="col-auto">
                  <img
                    loading="lazy"
                    src="images/visa.png"
                    alt="Visa"
                    class="img-responsive"
                    width="25"
                    height="auto"
                  />
                </div>
                <div class="col-auto">
                  <img
                    loading="lazy"
                    src="images/masterCard.png"
                    alt="MasterCard"
                    class="img-responsive"
                    width="25"
                    height="auto"
                  />
                </div>
                <div class="col-auto">
                  <img
                    loading="lazy"
                    src="images/americanExpress.png"
                    alt="American Express"
                    class="img-responsive"
                    width="25"
                    height="auto"
                  />
                </div>
                <div class="col-auto">
                  <img
                    loading="lazy"
                    src="images/carnet.png"
                    alt="Carnet"
                    class="img-responsive"
                    width="35"
                    height="auto"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-auto">
              <p class="text-left">Tarjetas de Débito</p>
              <div class="row mb-4">
                <div class="col-auto">
                  <img
                    loading="lazy"
                    src="images/bbva.png"
                    alt="BBVA"
                    class="img-responsive"
                    width="48"
                    height="auto"
                  />
                </div>
                <div class="col-auto">
                  <img
                    loading="lazy"
                    src="images/santander.png"
                    alt="Santander"
                    class="img-responsive"
                    width="48"
                    height="auto"
                  />
                </div>
                <div class="col-auto">
                  <img
                    loading="lazy"
                    src="images/hsbc.png"
                    alt="HSBC"
                    class="img-responsive"
                    width="48"
                    height="auto"
                  />
                </div>
                <div class="col-auto">
                  <img
                    loading="lazy"
                    src="images/scotiabank.png"
                    alt="Scotiabank"
                    class="img-responsive"
                    width="48"
                    height="auto"
                  />
                </div>
                <div class="col-auto">
                  <img
                    loading="lazy"
                    src="images/inbursa.png"
                    alt="Inbursa"
                    class="img-responsive"
                    width="48"
                    height="auto"
                  />
                </div>
                <div class="col-auto">
                  <img
                    loading="lazy"
                    src="images/ixe.png"
                    alt="IXE"
                    class="img-responsive"
                    width="48"
                    height="auto"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <input
              type="text"
              name="openpay_holder_name"
              id="openpay_holder_name"
              class="form-control"
              placeholder="Nombre en la tarjeta"
              data-openpay-card="holder_name"
            />
          </div>
          <div class="form-row mb-3">
            <div class="col-10">
              <input
                type="text"
                maxlength="16"
                name="openpay_card_number"
                id="openpay_card_number"
                class="form-control"
                placeholder="Número de la tarjeta"
                data-openpay-card="card_number"
              />
            </div>
            <div class="col-2">
              <input
                type="text"
                name="openpay_card_cvv"
                maxlength="4"
                id="openpay_card_cvv"
                class="form-control"
                placeholder="***"
                data-openpay-card="cvv2"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="col-6">
              <select
                name="openpay_card_month"
                id="openpay_card_month"
                data-openpay-card="expiration_month"
                class="form-control"
              >
                <option value="0">.: Elige el mes :.</option>
                <option
                  v-for="(month, index) in card_months"
                  :key="index"
                  :value="month"
                >
                  {{ month }}
                </option>
              </select>
            </div>
            <div class="col-6">
              <select
                name="openpay_card_year"
                id="openpay_card_year"
                data-openpay-card="expiration_year"
                class="form-control"
              >
                <option value="0">.: Elige el año :.</option>
                <option
                  v-for="(year, index) in card_years"
                  :key="index"
                  :value="year.toString().substr(-2)"
                >
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group my-3" v-if="total >= 1000">
            <small class="text-left d-block" style="color: red"
              >Pago a meses solo a partir de $1000
            </small>
            <select
              name="months_to_pay"
              id="months_to_pay"
              v-model="months"
              class="form-control"
            >
              <option value="0">.: Pago a meses :.</option>
              <option value="3">3 meses</option>
              <option value="6">6 meses</option>
              <option value="9">9 meses</option>
            </select>
          </div>
          <input
            type="hidden"
            data-openpay-card-address="line1"
            :value="address.street"
          />
          <input
            type="hidden"
            data-openpay-card-address="line2"
            :value="address.no_ext"
          />
          <input
            type="hidden"
            data-openpay-card-address="line3"
            :value="address.references"
          />
          <input
            type="hidden"
            data-openpay-card-address="postal_code"
            :value="address.cp"
          />
          <input
            type="hidden"
            data-openpay-card-address="city"
            :value="address.state"
          />
          <input
            type="hidden"
            data-openpay-card-address="state"
            :value="address.state"
          />
          <input
            type="hidden"
            data-openpay-card-address="country_code"
            value="MX"
          />
          <input type="hidden" name="device_token_id" />
        </div>
        <div class="text-end p-1">
          Transacciones realizadas via:
          <img
            src="images/openpay_color.png"
            alt="openpay"
            class="img-responsive"
            width="100"
            height="auto"
          /><br /><br />
          <span class="text-danger"
            >Al dar click al botón de pago se te redirigirá a 3dSecure</span
          >
        </div>
      </div>
      <div class="form-group pt-2">
        <loading :active.sync="is_loading"></loading>
        <button
          @click="placeOrder"
          :disabled="desactivar"
          class="btn btn-success btn-lg py-3 btn-block"
        >
          Procede al pago
        </button>
      </div>
    </div>
    <!-- Openpay -->
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
  name: "OpenPay",
  props: [
    "is_openpay",
    "card_months",
    "card_years",
    "total",
    "address",
    "receiver",
    "userData",
    "products",
  ],
  components: {
    Loading,
  },
  data() {
    return {
      desactivar: false,
      is_loading: false,
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      local_url: process.env.VUE_APP_SUSCRIPTIONS_LOCAL_ROUTE,
      is_sandbox_mode: process.env.VUE_APP_SANDBOX_MODE,
      openPayCustomerId: null,
      deviceSessionId: null,
      openpay_id: process.env.VUE_APP_OPENPAY_ID,
      openpay_key: process.env.VUE_APP_OPENPAY_APIKEY,
      codeCoupon: "",
      months: 0,
    };
  },
  mounted() {
    let openpay_script = document.createElement("script");
    openpay_script.setAttribute(
      "src",
      "https://js.openpay.mx/openpay.v1.min.js"
    );
    document.head.appendChild(openpay_script);
    let openpay_data_script = document.createElement("script");
    openpay_data_script.setAttribute(
      "src",
      "https://js.openpay.mx/openpay-data.v1.min.js"
    );
    document.head.appendChild(openpay_data_script);
  },
  methods: {
    sendDataOpenPay: function () {
      this.desactivar = true;
      try {
        OpenPay.setId(this.openpay_id);
        OpenPay.setApiKey(this.openpay_key);
        this.deviceSessionId = OpenPay.deviceData.setup(
          "op_processCard",
          "deviceIdHiddenFieldName"
        );
        if (
          this.deviceSessionId === null ||
          this.deviceSessionId === undefined ||
          this.deviceSessionId === ""
        ) {
          this.is_loading = false;
          this.$snotify.error("Error al intentar hacer el pago");
        }
        OpenPay.setSandboxMode(this.is_sandbox_mode);
        if (!OpenPay.card.validateCardNumber($("#openpay_card_number").val())) {
          this.$snotify.error("El número de tarjeta no es valido");
          this.is_loading = false;
          this.desactivar = false;
        } else if (!OpenPay.card.validateCVC($("#openpay_card_cvv").val())) {
          this.$snotify.error("El código CVC no es valido");
          this.is_loading = false;
          this.desactivar = false;
        } else if (
          !OpenPay.card.validateCVC(
            $("#openpay_card_cvv").val(),
            $("#openpay_card_number").val()
          )
        ) {
          this.$snotify.error(
            "El código CVC no es valido para la tarjeta ingresada"
          );
          this.is_loading = false;
          this.desactivar = false;
        } else {
          OpenPay.token.extractFormAndCreate(
            $("#op_processCard"),
            this.successOpenpay,
            this.errorOpenpay,
            this.openPayCustomerId
          );
        }
      } catch (error) {
        this.$snotify.error("Error al intentar hacer el pago");
        this.desactivar = false;
        this.is_loading = false;
      }
    },
    successOpenpay: function (response) {
      console.info("Respuesta correcta de Openpay");
      console.error(response);
      axios({
        method: "POST",
        url: this.api_url + "/payment/openpayCard",
        data: {
          user_id: $cookies.get("uidmmkg"),
          token: response.data.id,
          months: this.months,
          items: this.products,
          address: this.address,
          receiver: this.receiver,
          deviceIdHiddenFieldName: this.deviceSessionId,
          redirect_url: this.local_url + "/thanksOpenpay",
          code: this.codeCoupon,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
        .then((response) => {
          console.info("dta", this.products);
          console.info("respuesta de pago en servidor");
          console.info(response);
          if (response.data.status) {
            this.$store.commit("saveSeveralProducts", this.products);
            this.addToTagManager(
              this.products,
              this.months,
              this.address,
              "El metodo de pago es por OpenPay Tarjetas",
              new Date().toLocaleString("en-US")
            );
            this.$snotify.info("Redirigiendo a Openpay");
            console.info(response.data.redirect_url);
            window.location.href = response.data.redirect_url;
          } else {
            this.$snotify.warning(response.data.message);
          }
          this.desactivar = false;
          this.is_loading = false;
        })
        .catch((error) => {
          this.is_loading = false;
          this.desactivar = false;
          this.$snotify.error(error);
        });
    },
    errorOpenpay: function (response) {
      console.error("Error en validación de pago en Openpay");
      console.error(response);
      this.$snotify.error(response.message);
      this.is_loading = false;
      this.desactivar = false;
    },
    placeOrder: function () {
      this.desactivar = true;
      this.is_loading = true;
      this.fillReceiverName();
      this.fillMonths();
      this.validateAddressAndSendToOpenPay();
    },
    fillReceiverName: function () {
      if (this.receiver.name.length === 0 || this.receiver.name === "") {
        this.receiver.name = this.userData.name + " " + this.userData.lastname;
      }
    },
    fillMonths: function () {
      if (this.months == 0) {
        this.months = 1;
      }
    },
    validateAddressAndSendToOpenPay: function () {
      if (jQuery.isEmptyObject(this.address)) {
        this.desactivar = false;
        this.$snotify.warning(
          "Falta la dirección de envío. Selecciona o registra una dirección de envío"
        );
        this.is_loading = false;
      } else {
        this.sendDataOpenPay();
      }
    },
    addToTagManager: function (
      products,
      months,
      address,
      paymentMethod,
      datePayment
    ) {
      window.dataLayer.push({
        event: "Pago",
        pageURL: this.$router.currentRoute.fullPath,
        product: products,
        months: months,
        address: address,
        paymentMethod: paymentMethod,
        datePayment: datePayment,
      });
    },
  },
};
</script>

<style>
</style>